/** Shows the price of the chosen variant on the product page. */
const variantSelect = document.querySelector('[data-product-variant]');
const price = document.querySelector('[data-product-price]');

if (variantSelect && price) {
  variantSelect.addEventListener('change', () => {
    price.textContent = variantSelect.selectedOptions[0].dataset.price;
  });
}

/** Quantity stepper, and the offer buttons that pick a quantity for it. */
document.querySelectorAll('.product-form form').forEach((form) => {
  const quantity = form.querySelector('[data-product-quantity]');
  const offers = form.querySelectorAll('[data-product-offer]');
  if (!quantity) return;

  const setQuantity = (value) => {
    quantity.value = Math.max(1, value);
    offers.forEach((offer) => {
      offer.checked = offer.value === quantity.value;
    });
  };

  form.querySelectorAll('[data-quantity-step]').forEach((button) => {
    button.addEventListener('click', () => {
      setQuantity(Number(quantity.value) + Number(button.dataset.quantityStep));
    });
  });
  // Each offer also shows its own image in the gallery: 1 the first, 2 the second.
  const gallery = form.closest('.product')?.querySelector('[data-gallery]');
  offers.forEach((offer) => {
    offer.addEventListener('change', () => {
      setQuantity(Number(offer.value));
      gallery?.dispatchEvent(new CustomEvent('gallery:show', { detail: Number(offer.value) - 1 }));
    });
  });
  quantity.addEventListener('change', () => setQuantity(Number(quantity.value) || 1));
});

/** Read more: opens the text that is cut off after three lines, and closes it again. The height animates in CSS. */
document.querySelectorAll('[data-read-more]').forEach((readMore) => {
  const text = readMore.querySelector('[data-read-more-text]');
  const toggle = readMore.querySelector('[data-read-more-toggle]');
  if (!text || !toggle) return;

  if (text.scrollHeight <= text.clientHeight + 1) {
    readMore.dataset.readMore = 'fits';
    return;
  }

  toggle.hidden = false;
  // Once open, the text is free to grow again when the window is resized.
  text.addEventListener('transitionend', () => {
    if (readMore.dataset.readMore === 'open') text.style.maxHeight = 'none';
  });
  toggle.addEventListener('click', () => {
    const open = readMore.dataset.readMore !== 'open';
    // A transition needs a height in pixels on both ends: closing starts from it, opening ends on it.
    text.style.maxHeight = `${text.scrollHeight}px`;
    if (!open) {
      text.offsetHeight;
      text.style.maxHeight = '';
    }
    readMore.dataset.readMore = open ? 'open' : '';
    toggle.setAttribute('aria-expanded', String(open));
    toggle.textContent = open ? toggle.dataset.labelLess : toggle.dataset.labelMore;
  });
});

/** Product gallery: arrows and thumbnails scroll the track, which marks the thumbnail in view. */
document.querySelectorAll('[data-gallery]').forEach((gallery) => {
  const track = gallery.querySelector('[data-gallery-track]');
  const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
  if (!track || thumbs.length === 0) return;

  const current = () => Math.round(track.scrollLeft / track.clientWidth);
  const show = (index) => {
    const wrapped = (index + thumbs.length) % thumbs.length;
    track.scrollTo({ left: wrapped * track.clientWidth });
  };

  gallery.querySelectorAll('[data-gallery-step]').forEach((button) => {
    button.addEventListener('click', () => show(current() + Number(button.dataset.galleryStep)));
  });
  thumbs.forEach((thumb, index) => {
    thumb.addEventListener('click', () => show(index));
  });
  gallery.addEventListener('gallery:show', (event) => show(event.detail));
  track.addEventListener('scroll', () => {
    thumbs.forEach((thumb, index) => {
      if (index === current()) {
        thumb.setAttribute('aria-current', 'true');
      } else {
        thumb.removeAttribute('aria-current');
      }
    });
  });
});
